flatten2.defaults.delimiter = "."

module.exports = (obj) ->
    try
        _.extend({}, obj, flatten2.flatten(obj))
    catch
        obj
